import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '@environments/environment';
import { DashboardState, dashboardReducer } from '@features/dashboard/store';
import { DocumentState, documentReducer } from '@features/documents/store';
import { ApiKeysState, apiKeysReducer } from '@features/api-keys/store';
import { TemplatesState, templatesReducer } from '@features/templates/store';
import { BillingState, billingReducer } from '@features/billing/store';
import { SettingsState, settingsReducer } from '@features/settings/store';
import { WebhookState, webhookReducer } from '@features/webhooks/store';
import { AnalyticsState, analyticsReducer } from '@features/analytics/store';
import { UsageReportState, usageReportsReducer } from '@features/usage-reports/store';
import { SupportState, supportReducer } from '@features/support/store';

/**
 * Root state interface
 * Add feature states here as they are created
 */
export interface AppState {
  dashboard: DashboardState;
  documents: DocumentState;
  apiKeys: ApiKeysState;
  templates: TemplatesState;
  billing: BillingState;
  settings: SettingsState;
  webhooks: WebhookState;
  analytics: AnalyticsState;
  usageReports: UsageReportState;
  support: SupportState;
}

/**
 * Root reducers
 * Add feature reducers here as they are created
 */
export const reducers: ActionReducerMap<AppState> = {
  dashboard: dashboardReducer,
  documents: documentReducer,
  apiKeys: apiKeysReducer,
  templates: templatesReducer,
  billing: billingReducer,
  settings: settingsReducer,
  webhooks: webhookReducer,
  analytics: analyticsReducer,
  usageReports: usageReportsReducer,
  support: supportReducer
};

/**
 * Debug meta-reducer to log document-related actions
 * This helps identify what's causing repeated API calls
 */
export function debugDocumentActionsReducer(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
  return (state, action) => {
    // Log document-related actions
    if (action.type.includes('[Documents]')) {
      console.log(`[NgRx Debug] ${action.type}`, {
        timestamp: new Date().toISOString(),
        action: action,
        stack: new Error().stack?.split('\n').slice(2, 6).join('\n')
      });
    }
    return reducer(state, action);
  };
}

/**
 * Meta-reducers for global state management
 * In development mode, includes debugging meta-reducer
 */
export const metaReducers: MetaReducer<AppState>[] = !environment.production
  ? [debugDocumentActionsReducer]
  : [];

/**
 * Selectors will be exported from feature modules
 */

